// Shared vertical rhythm for the panel. One home for these so a row can never be
// half a step out of line with the one above it — the first pass let the Spouse
// tile sit shorter than Brother/Sister, because each control brought its own
// minHeight and a Tooltip-wrapped tile did not stretch to its grid row.
//
// Height stopped being a design constraint on 2026-08-18 (Tim): the original
// ~410px target predated the reproductive launchers, and the tiles it produced
// read as cramped — symbol and label almost touching. These values are chosen for
// legibility first.

/** Every tile, and every chip that replaces one, is exactly this tall. */
export const TILE_HEIGHT = 72;

/**
 * Fixed height for a tile's glyph, whatever glyph it is.
 *
 * Without this the row height followed the SYMBOL: the joined square-and-circle of
 * Parents/Spouse is shorter than a lone square, so Earlier generations came out
 * 68px while Current generation came out 72px — uniform within each row, but a
 * visible 4px step between two adjacent rows, and a chip (which has no glyph)
 * different again. Reserving the slot decouples the row height from the notation.
 */
export const SYMBOL_SLOT = 28;

/**
 * Space between one group and the next, in MUI spacing units.
 *
 * Shared because it was already 1.75 in RelativeGroup and 1.5 in ChildScope, which
 * sat the Children group 2px closer to Current generation than the others were to
 * each other. Two homes for one measurement is how that happens.
 */
export const GROUP_GAP = 1.75;

/**
 * The full-width launcher rows. Shorter than a tile on purpose: they are a
 * horizontal row with the glyph beside the label rather than above it, so they
 * need no vertical room for a second line, and the difference helps them read as
 * a different class of control — one that opens a form rather than adding a node.
 * All three are identical to each other, which is what keeps Other aligned.
 */
export const LAUNCHER_HEIGHT = 56;
